import React from 'react';
import { connect } from 'react-redux';
import PT from 'prop-types';
import classNames from 'classnames';
import _ from 'lodash';
import { Responsive } from 'common/components';
import footerImg from 'assets/client/imgs/footer-bg.jpg';
import footerImgMobile from 'assets/client/imgs/footer-bg-mobile.jpg';
import yitLogo from 'assets/client/imgs/yit-footer.png';
import poweredBy from 'assets/client/imgs/logo-powered-by.png';
import MailTo from '../MailTo';
import Container from '../Container';

import * as css from './Footer.scss';

const Footer = ({ settings, className }) => {
	const footerTitle = _.get(settings, 'footer.footerTitle', '');
	const footerSubtitle = _.get(settings, 'footer.footerSubtitle', '');
	const btnText = _.get(settings, 'footer.buttonText', '');

	return (
		<React.Fragment>
			<div className={classNames(css.footer, className)}>
				<Responsive query={Responsive.DESKTOP}>
					<div className={css.footerTop} style={{ backgroundImage: `url(${footerImg})` }}>
						<Container className={css.footerTopContainer}>
							<MailTo>
								<p>{btnText}</p>
							</MailTo>
							<div className={css.text}>
								<p className={css.footerTitle}>{footerTitle}</p>
								<p className={css.footerSubtitle}>{footerSubtitle}</p>
							</div>
						</Container>
					</div>
				</Responsive>
				<Responsive query={Responsive.MOBILE}>
					<div className={css.footerTop} style={{ backgroundImage: `url(${footerImgMobile})` }}>
						<Container className={css.footerTopContainer}>
							<MailTo>
								<p>{btnText}</p>
							</MailTo>
							<div className={css.text}>
								<p className={css.footerTitle}>{footerTitle}</p>
								<p className={css.footerSubtitle}>{footerSubtitle}</p>
							</div>
						</Container>
					</div>
				</Responsive>
				<div className={css.footerBottom}>
					<a
						// eslint-disable-next-line max-len
						href="https://yit.co.il?utm_source=rafael.poweredby.yit.co.il&utm_medium=referral&utm_campaign=Poweredby_Rafael"
						className={css.yitLogoLink}
					>
						<img src={yitLogo} alt="yit-logo" />
					</a>
					<span>פיתוח</span>
					<a
						// eslint-disable-next-line max-len
						href="https://poweredby.yit.co.il/?utm_source=rafael.poweredby.yit.co.il&utm_medium=referral&utm_campaign=Poweredby_Rafael"
					>
						<img src={poweredBy} alt="powered-by" className={css.poweredBy} />
					</a>
					<a href="https://z.ynet.co.il/short/content/2018/PrivacyPolicy/poweredbypolicy.html">
						<span className={css.textWithLine}>איפיון ועיצוב</span>
					</a>
					<a href="https://z.ynet.co.il/short/content/2018/PrivacyPolicy/poweredbypolicy.html">
						<span>תנאי שימוש ומדיניות פרטיוות</span>
					</a>
				</div>
			</div>
		</React.Fragment>
	);
};

Footer.defaultProps = {
	className: '',
};

Footer.propTypes = {
	className: PT.string,
	settings: PT.shape({}).isRequired,
};

export default connect(
	({ settings }) => ({ settings }),
	null
)(Footer);
